/**
 * DOC UPLOAD MODAL REDUCER
 *
 * Drives the global, reusable loan-document upload modal
 * (LoanDocumentUploadModal) so it can be opened from anywhere in the drilldown
 * (Loan Info borrower card, Add To Loan sidebar, etc.).
 *
 * State:
 *   open     — whether the modal is showing.
 *   assignTo — null (upload directly to the loan, picker shown) OR
 *              { type: "borrower" | "property", id, label } to lock the upload
 *              to a specific entity (picker hidden, label shown read-only).
 *   initialView  — optional UPLOAD_TYPES value to open on (default Quick Upload).
 *   initialFiles — optional queue entries to seed the review bar with, for
 *              callers that already collected the files themselves (a drop on a
 *              surface with no UploadQueueProvider around it, e.g. the Add To
 *              Loan panel's dropzone). Non-serializable File objects — fine
 *              here, the store runs with the serializable check off.
 */
const init = {
  open: false,
  assignTo: null,
  initialView: null,
  initialFiles: null,
};

const docUploadModalReducer = (state = init, action) => {
  switch (action.type) {
    case "DOC_UPLOAD_MODAL_OPEN":
      return {
        open: true,
        assignTo: action.payload?.assignTo ?? null,
        initialView: action.payload?.initialView ?? null,
        initialFiles: action.payload?.initialFiles ?? null,
      };
    case "DOC_UPLOAD_MODAL_CLOSE":
      return init;
    default:
      return state;
  }
};

export default docUploadModalReducer;
